<template>
	<hr :id="blok.anchor" v-editable="blok" class="invisible h-0" aria-hidden="true" />
</template>

<script setup lang="ts">
	import type {AnchorStoryblok} from '@/storyblok/types';

	interface Props {
		blok: AnchorStoryblok
	}

	defineProps<Props>();
</script>
